// CartSidebar.js
import React from 'react';
import CartSummary from '../CartSummary/CartSummary';
import './CartSidebar.css';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const CartSidebar = ({ onClose, position = 'right' }) => {
  const navigate = useNavigate();

  return (
<div className="cart-sidebar-overlay" onClick={onClose}>
  <div
    className={`cart-sidebar ${position === 'left' ? 'left' : 'right'}`}
    onClick={(e) => e.stopPropagation()} // מונע סגירה כשהמשתמש לוחץ בפנים
  >
    <div className="cart-sidebar-header">
      <h2>🛒 סל הקניות</h2>
      <FaTimes onClick={onClose} className="close-icon" />
    </div>

    <div className="cart-sidebar-content">
      <CartSummary />
    </div>

    <div className="cart-sidebar-footer">
      <button
        className="go-to-checkout-btn"
        onClick={() => {
          onClose();
          navigate('/cashout');
        }}
      >
        🧾 מעבר לתשלום
      </button>
    </div>
  </div>
</div>

  );
};


export default CartSidebar;
